exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".side-menu[data-v-6516e9f8] {\n  transition: all 0.6s;\n  list-style-type: none;\n}\n.side-menu > .menu-item > h6 > a[data-v-6516e9f8]:hover {\n  text-decoration: none;\n}\n.side-menu > .menu-item[data-v-6516e9f8] {\n  font-weight: 500;\n}\n.menu-title[data-v-6516e9f8] {\n  font-size: 90%;\n}", ""]);

// exports
